var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('router-view',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.newtitle),expression:"newtitle"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }